var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1201(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M299.102,846.669l620.503,0.221c-0,0 216.75,-23.059 219.916,-236.76c3.33,-224.86 -232.99,-238.897 -239.362,-250.132c-47.329,-83.459 -79.506,-195.962 -287.054,-197.153c-257.08,-1.476 -293.688,300.727 -304.013,303.136c-77.706,18.13 -200.027,47.336 -198.726,207.124c1.303,160.154 188.736,173.564 188.736,173.564Z",
    style: {
      fill: "#e5e5e5"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.697,449.874c-84.017,19.989 -205.437,56.762 -204.081,223.384c0.725,89.064 52.962,137.482 105.261,163.477c50.52,25.111 100.887,28.636 100.887,28.636c0.443,0.032 0.887,0.048 1.332,0.048l620.502,0.221c0.665,0 1.329,-0.035 1.99,-0.105c0,-0 233.272,-24.981 236.681,-255.127c2.856,-192.835 -157.499,-242.084 -225.734,-259.816c-7.358,-1.912 -14.893,-3.989 -19.038,-5.149c-28.386,-51.178 -53.451,-111.083 -112.633,-152.129c-41.462,-28.756 -99.603,-48.714 -187.651,-49.219c-123.55,-0.709 -199.524,64.068 -246.611,135.979c-44.562,68.055 -62.584,142.476 -70.905,169.8Zm4.133,378.042c-5.401,-0.479 -45.757,-4.629 -86.262,-24.762c-41.743,-20.748 -83.874,-59.112 -84.453,-130.202c-1.195,-146.813 112.841,-172.053 184.238,-188.712c3.265,-0.762 7.347,-2.489 10.97,-6.967c1.379,-1.705 3.422,-5.056 5.261,-10.291c1.994,-5.674 4.679,-15.536 8.412,-28.35c21.596,-74.127 80.918,-258.152 275.002,-257.038c77.992,0.448 129.768,17.063 166.495,42.534c56.043,38.869 77.217,97.262 104.357,145.119c1.48,2.611 4.302,6.215 9.884,8.956c4.382,2.152 14.849,4.91 29.37,8.684c59.074,15.351 200.141,56.02 197.669,222.966c-2.807,189.51 -187.732,216.461 -202.25,218.285c-0.012,0.002 -618.654,-0.219 -618.654,-0.219l-0.039,-0.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M617.167,931.637l-89.733,155.423",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.662,931.637l-89.733,155.423",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.273,931.637l-89.734,155.423",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.812,929.408l180.198,0.018l-93.176,157.673l-87.022,-157.691Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1201);
export default __webpack_public_path__ + "static/media/1201.d4c1fc81e708d2bbc9621eb8a63fe6a7.svg";
export { ForwardRef as ReactComponent };